module.exports = __webpack_public_path__ + "static/media/friends-of-tmc-icon.c6c461f3.svg";